import { APIInstance } from '../../';
import { API } from '../../api';

export default {
    infants(id) {
        return new Promise((resolve, reject) => {
            API.csrfCookie().then(() => {
                APIInstance.get(`/api/appinfants/${id}`).then(r => {
                    resolve(r.data);
                }).catch(err => {
                    reject(err);
                });
            }).catch(err => {
                reject(err);
            });
        });
    },

    applyInfants(values) {
        return new Promise((resolve, reject) => {
            API.csrfCookie().then(() => {
                APIInstance.post(`/api/appinfants`, values).then(r => {
                    resolve(r.data);
                }).catch(err => {
                    reject(err);
                });
            }).catch(err => {
                reject(err);
            });
        });
    },

    updateInfants(id, values) {
        return new Promise((resolve, reject) => {
            API.csrfCookie().then(() => {
                APIInstance.post(`/api/appinfants/${id}`, values).then(r => {
                    resolve(r.data);
                }).catch(err => {
                    reject(err);
                });
            }).catch(err => {
                reject(err);
            });
        });
    },

    addInfantPayment(id, values) {
        return new Promise((resolve, reject) => {
            API.csrfCookie().then(() => {
                APIInstance.post(`/api/appinfantpayments`, Object.assign({}, { appinfant_id: id }, values)).then(r => {
                    resolve(r.data);
                }).catch(err => {
                    reject(err);
                });
            }).catch(err => {
                reject(err);
            });
        });
    },

    getInfantPaymentsForInfant(id) {
        return new Promise((resolve, reject) => {
            API.csrfCookie().then(() => {
                APIInstance.get(`/api/appinfants/payments/${id}`).then(r => {
                    resolve(r.data);
                }).catch(err => {
                    reject(err);
                });
            }).catch(err => {
                reject(err);
            });
        });
    },

    infantPayment(id) {
        return new Promise((resolve, reject) => {
            API.csrfCookie().then(() => {
                APIInstance.get(`/api/appinfantpayments/${id}`).then(r => {
                    resolve(r.data);
                }).catch(err => {
                    reject(err);
                });
            }).catch(err => {
                reject(err);
            });
        });
    },

    updateInfantPayments(id, values) {
        return new Promise((resolve, reject) => {
            API.csrfCookie().then(() => {
                APIInstance.post(`/api/appinfantpayments/${id}`, values).then(r => {
                    resolve(r.data);
                }).catch(err => {
                    reject(err);
                });
            }).catch(err => {
                reject(err);
            });
        });
    },

    countInfantpayments(id) {
        return new Promise((resolve, reject) => {
            API.csrfCookie().then(() => {
                APIInstance.get(`/api/appinfantpayments/count/${id}`).then(r => {
                    resolve(r.data);
                }).catch(err => {
                    reject(err);
                });
            }).catch(err => {
                reject(err);
            });
        });
    }
};
